var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPositionsCount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0762 0.923077C11.0762 0.413276 11.4894 0 11.9992 0C18.6206 0 23.9993 5.36645 23.9993 12.0001V23.0769C23.9993 23.5867 23.586 24 23.0762 24C16.4549 24 11.0762 18.6337 11.0762 12.0001V0.923077ZM12.9223 1.88757V12.0001C12.9223 17.3012 16.9819 21.6462 22.1532 22.1124V12.0001C22.1532 6.69894 18.0936 2.3538 12.9223 1.88757Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.9992C0 11.4894 0.413276 11.0762 0.923077 11.0762H12C12.5098 11.0762 12.9231 11.4894 12.9231 11.9992V23.0761C12.9231 23.5859 12.5098 23.9992 12 23.9992C5.37862 23.9992 0 18.6329 0 11.9992ZM1.88752 12.9223C2.32658 17.7971 6.20919 21.6728 11.0769 22.1116V12.9223H1.88752Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.923077C0 0.413276 0.413276 0 0.923077 0C7.54447 0 12.9231 5.36646 12.9231 12.0001C12.9231 12.5099 12.5098 12.9231 12 12.9231H0.923077C0.413276 12.9231 0 12.5099 0 12.0001V0.923077ZM1.84615 1.88757V11.077H11.0356C10.5965 6.20217 6.71388 2.32643 1.84615 1.88757Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionsCount);
export default __webpack_public_path__ + "static/media/positions_count.7114cd9fb1aca42982cd6c5ee7e81c7a.svg";
export { ForwardRef as ReactComponent };